import { render, staticRenderFns } from "./InspectionResultHeader.vue?vue&type=template&id=badeb33c&class=true"
import script from "./InspectionResultHeader.vue?vue&type=script&lang=js"
export * from "./InspectionResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports